module.exports = __webpack_public_path__ + "img/minus_btn.94d5f65e.png";